var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-laptop",
    transform: "translate(-2290 -10229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 40,
    height: 40,
    transform: "translate(2290 10229)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ico_laptop",
    d: "M40.665,37.143H39.544V17.086A3.076,3.076,0,0,0,36.484,14H6.6a3.076,3.076,0,0,0-3.06,3.086V37.143H2.423c-.345,0-.545.607-.334,1.029L3.6,41.257a1.6,1.6,0,0,0,1.342,1.029h33.2a1.585,1.585,0,0,0,1.342-1.029L41,38.171C41.205,37.75,41.01,37.143,40.665,37.143ZM5.087,17.086A1.529,1.529,0,0,1,6.6,15.543H36.479A1.529,1.529,0,0,1,38,17.086V37.143H5.087ZM38.1,40.578a.708.708,0,0,1-.1.165H5.087a1.4,1.4,0,0,1-.1-.165l-.926-1.893H39.03ZM20.515,18.114a1.029,1.029,0,1,1,1.029,1.029A1.032,1.032,0,0,1,20.515,18.114Z",
    transform: "translate(2288.457 10221)",
    fill: "#646464"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLaptop);
export default __webpack_public_path__ + "static/media/ico-laptop.dabbdc4e43e36752272876bbce7de81b.svg";
export { ForwardRef as ReactComponent };